import { render } from "./UsageReport.vue?vue&type=template&id=28add6cc&scoped=true"
import script from "./UsageReport.vue?vue&type=script&lang=js"
export * from "./UsageReport.vue?vue&type=script&lang=js"

import "./UsageReport.vue?vue&type=style&index=0&id=28add6cc&lang=scss&scoped=true"
import "./UsageReport.vue?vue&type=style&index=1&id=28add6cc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28add6cc"]])

export default __exports__